import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {TaxPlanningService} from "../tpiq-services/tax-planning.service";
import {NgxScrollEvent} from "../directives/ngx-scroll-event.directive";
import {SwitchBoard} from "../services/SwitchBoard";
import {takeUntil} from "rxjs/operators";
import {Session} from "../services/Session";
import {environment} from "../../environments/environment";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'app-tpiq-chat-bot',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './tpiq-chat-bot.component.html',
  styleUrl: './tpiq-chat-bot.component.scss'
})
export class TpiqChatBotComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  showChatPannel = false;
  smarterCodesframe: any;
  botUrl = "";
  currentEnvironment: any;
  showEscalation = false;
  escalationMessage = '';

  @Output() public onJaineEscalation = new EventEmitter<NgxScrollEvent>();
  
  constructor(
    private switchBoard: SwitchBoard,
    private taxPlanningService: TaxPlanningService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();

    this.currentEnvironment = environment;
    if (this.currentEnvironment.production){
      this.botUrl = "https://chat-tpiq-prod.smarter.codes";
    } else {
      this.botUrl = "https://chat-taxplaniq.smarter.codes";
    }
    if (this.changeDetectorRef){
      this.changeDetectorRef.detectChanges();
    }
    this.smarterCodesframe = document.querySelector("#smarterCodesframeId");
    this.switchBoard.onPageChangeListener.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data){
        this.smarterCodesframe.contentWindow.postMessage({
          type: 'pageChangeEvent',
          url: data.url,
          name: data.name,
          id: data.id
        }, "*");
      }
    });
    this.smarterCodesframe.onload = () => {
      try{
        setTimeout(() => {
          this.smarterCodesframe.contentWindow.postMessage({
            type: 'userIdResponse',
            userId: Session.getUser().id,
            orgId: Session.getOrg(),
            userName: this.user.first_name + ' ' + this.user.last_name,
            isFirstLogin: this.taxPlanningService.getUserFirstLogin()
          }, "*");
        }, 500);
        window.addEventListener("message", (event) => {
          if (event.data.type === 'jaineEscalation'){
            this.showEscalation = true;
            this.escalationMessage = event.data.message;
          }
        });
      } catch (e) {}
      window.addEventListener("getUserIdFromSession", (event) => {
        console.log("Message from Smarter Codes: ", event);
        this.smarterCodesframe.contentWindow.postMessage({
          type: 'userIdResponse',
          userId: Session.getUser().id,
          orgId: Session.getOrg(),
          userName: this.user.first_name + ' ' + this.user.last_name,
          isFirstLogin: this.taxPlanningService.getUserFirstLogin()
        }, "*");
      });
    };

    // Add chatbot widget dynamically
    const buttonBackgroundUrl = `${window.location.origin}/images/jaine-bot.png`;
    
    /** Knolli Script Start */
      const hostUrl = window.location.host;
      const knolliUrl = this.currentEnvironment.KNOLLI_CHAT_URL;
      const aiAssistantId = this.currentEnvironment.jaineAiAssistantId;
      const knolliStageScript = this.renderer.createElement('script');
      const fileUploadParam = this.currentEnvironment.production ? "&hideFileUpload=true" : "&hideFileUpload=false";
      knolliStageScript.src =
        knolliUrl+"/content/css/widget.js" +
        "?url=" + encodeURIComponent(knolliUrl+"/knolli/"+aiAssistantId) +
        "&title=" + encodeURIComponent("Welcome to Jaine - V2") +
        "&subtitle=" + encodeURIComponent("Hi! I'm jAIne, your dedicated AI tax manager.Feel free to ask me anything about tax planning in your practice, including marketing and education, or copy/paste info to me.Share relevant facts and circumstances without providing sensitive  client data. I strive to be as accurate as possible, but I can make  mistakes. Write Escalate followed by any discrepancy you find, and our team will make it better!") +
        "&placeholder=" +  encodeURIComponent("Ask jAIne about tax planning") +
        "&host=" + encodeURIComponent(`${hostUrl}`) +
        "&icon=" + encodeURIComponent(`${buttonBackgroundUrl}`) +
        "&buttonBackground=" + encodeURIComponent(`url('${buttonBackgroundUrl}') no-repeat center / contain`) +
        "&headerText=jAIne 2.0" +
        "&welcomeMessage=true"+
        "&buttonText=''" +
        "&buttonHover=''" +
        "&buttonWidth=51px" +
        "&buttonHeight=60px" +
        "&buttonBorderRadius=0px" +
        "&buttonPosition_br=" + encodeURIComponent("44vh 6px") +
        "&fName=" + encodeURIComponent(`${this.user.first_name}`) +
        "&lName=" + encodeURIComponent(`${this.user.last_name}`) +
        "&orgName=" + encodeURIComponent(`${this.user.org}` +
        "&uEmail=" + encodeURIComponent(`${this.user.id}`) +
        fileUploadParam
        );

      knolliStageScript.async = true;
      this.renderer.appendChild(document.body, knolliStageScript);
    /** Knolli Script End */

      const interval = setInterval(() => {
        const footer = document.querySelector('.knolli-widget-footer');
        if (footer) {
          footer.textContent = 'jAIne is AI and can make mistakes. Please double-check responses.';
          clearInterval(interval);
        }
      }, 500);
  }
  

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  openChatbox() {
    this.showEscalation = false;
    this.showChatPannel = true;
  }

  closeChatbox() {
    this.showChatPannel = false;
  }

}
